enum PayeeType {
    UK = "UK",
    IBAN = "IBAN",
}
export default PayeeType